import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboMotivoDesligamentoComponent } from './combo-motivo-desligamento.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboMotivoDesligamentoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboMotivoDesligamentoComponent]
})
export class ComboMotivoDesligamentoModule { }
